module.exports = __webpack_public_path__ + "static/logo8-42d92b1c248b938aac73d2afb56cafef.png";